module.exports = require('./helpers/bundle-url').getBundleURL('2LpMj') + "close_white.e21be145.png" + "?" + Date.now();